export const QA_NAME_VIEWING_RESCHEDULE_MODAL = 'viewingReschedule'

export const QA_NAME_VIEWING_RESCHEDULE_SUBMIT = 'viewingRescheduleSubmit'

export const VIEWING_RESCHEDULE_FIELD_NAME = {
  duration: 'duration_min',
  start: 'start',
}
